<template>
  <div class="halloweenBox">
    <div class="alFitrBox langEn" :class="lang == 'ar' ? 'langAr':''">
      <div class="gift1"></div>
      <div class="gift2"></div>
      <div class="gift34Box">
        <div class="gift3"></div>
        <div class="gift4"></div>
      </div>
    </div>
    
  </div>
</template>

<script>
export default {
  name: "halloween",
  data() {
    return {
      lang:'ar'
    };
  },
  mounted() {
      this.$completes.complete("getUserInfo");
      window.getUserInfo = this.getUserInfo;
      window['getUserInfo'] = (data) => {
          this.getUserInfo(data);
      }
  },
  methods: {
    getUserInfo(data) {
      this.userInfo = JSON.parse(data);
      let langs = this.userInfo.lang.substring(0, 2)
      if (langs == "ar") {
        this.$i18n.locale = "ar";
        this.lang = "ar";
      } else {
        this.$i18n.locale = "en";
        this.lang = "en";
      }
        document.title = 'Halloween Event';
      
      document.querySelector("html").setAttribute("lang", this.$i18n.locale);
    }
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
.alFitrBox{
  width: 640px;
}
.langEn{
  height: 2616px;
  padding-top: 1800px;
  box-sizing: border-box;
  background: url('../../assets/halloween/enBg.png') no-repeat;
  background-size: 100% 100%;
}
.langAr{
  height: 2528px;
  padding-top: 1715px;
  background: url('../../assets/halloween/arBg.png') no-repeat;
  background-size: 100% 100%;
}
.gift1{
  width: 96px;
  height: 96px;
  background: url('../../assets/halloween/1.webp') no-repeat;
  background-size: 100% 100%;
  margin-left: 98px;
  box-sizing: border-box;
}
.gift2{
  width: 96px;
  height: 96px;
  background: url('../../assets/halloween/2.webp') no-repeat;
  background-size: 100% 100%;
  margin-left: 98px;
  margin-top: 180px;
  box-sizing: border-box;
}
.gift34Box{
  display: flex;
  align-items: center;
}
.gift3{
  width: 96px;
  height: 96px;
  background: url('../../assets/halloween/3.webp') no-repeat;
  background-size: 100% 100%;
  margin-left: 98px;
  margin-top: 180px;
  box-sizing: border-box;
  display: inline-block;
}
.gift4{
  display: inline-block;
  width: 110px;
  height: 40px;
  background: url('../../assets/halloween/4.webp') no-repeat;
  background-size: 100% 100%;
  margin-left: 72px;
  margin-top: 180px;
  box-sizing: border-box;
}
</style>
